import { render, staticRenderFns } from "./thong-bao.vue?vue&type=template&id=52980b50"
import script from "./thong-bao.vue?vue&type=script&lang=js"
export * from "./thong-bao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports